export default {"src":"/_next/static/media/playbook-onboarding-4.04600c01.svg","height":222,"width":330,"blurWidth":0,"blurHeight":0};